import NivelProduto from '@/spa/nivel-produto/NivelProduto';

export default {
  path: 'nivel-produto',
  name: 'nivel-produto',
  component: NivelProduto,
};
